<ridango-block-full-width
    *ngIf="(mediumGroups$ | async).length === 0 && isEmpty && !environment.PURCHASE.SHOW_MEDIUM_SELECTION_RADIO"
    [isEmpty]="isEmpty">
    <span class="step" role="text" attr.aria-label="{{ 'BLOCK_STEP_ARIA_LABEL' | translate }} {{ step }}">{{
        step
    }}</span>
    <h2 class="block-full-width__title" id="product_length_title">
        {{ 'MEDIUM_STEP_CHOOSE_MEDIUM_TYPE_TITLE' | uppercase | translate }}
    </h2>
</ridango-block-full-width>

<ridango-block-full-width
    *ngIf="!environment.PURCHASE.SHOW_MEDIUM_SELECTION_RADIO && (mediumGroups$ | async).length > 1"
    [isEmpty]="isEmpty"
    role="radiogroup"
    aria-labelledby="product_length_title_first">
    <span class="step" role="text" attr.aria-label="{{ 'BLOCK_STEP_ARIA_LABEL' | translate }} {{ step }}">{{
        step
    }}</span>
    <h2 class="block-full-width__title" id="product_length_title_first">
        {{ 'MEDIUM_STEP_CHOOSE_MEDIUM_TYPE_TITLE' | uppercase | translate }}
    </h2>

    <rwidget-medium-type-group-selector [locale]="locale" [step]="step" [isEmpty]="isEmpty">
    </rwidget-medium-type-group-selector>
</ridango-block-full-width>

<ridango-block-full-width
    *ngIf="environment.PURCHASE.SHOW_MEDIUM_SELECTION_RADIO"
    [isEmpty]="isEmpty"
    role="radiogroup"
    aria-labelledby="product_length_title_second">
    <span class="step" role="text" attr.aria-label="{{ 'BLOCK_STEP_ARIA_LABEL' | translate }} {{ step }}">{{
        step
    }}</span>
    <h2 class="block-full-width__title" id="product_length_title_second">
        {{ 'MEDIUM_STEP_CHOOSE_MEDIUM_TYPE_TITLE' | uppercase | translate }}
    </h2>

    <rwidget-medium-selector
        *ngIf="!isEmpty"
        [locale]="locale"
        [step]="step"
        [allowOnlyAddedCards]="allowPurchaseOnlyAddedCards"
        (mediumSelected)="setMedium($event)">
    </rwidget-medium-selector>
</ridango-block-full-width>

<ridango-block-full-width
    *ngIf="!environment.PURCHASE.SHOW_MEDIUM_SELECTION_RADIO && (selectedMediumGroup$ | async)"
    [removeMargin]="true"
    [isEmpty]="isEmpty">
    <!--    <span class="step" role="text" attr.aria-label="{{ 'BLOCK_STEP_ARIA_LABEL' | translate }} {{step}}">{{step}}</span>
    <h2 id="product_length_title" class="block-full-width__title">
        {{ 'CHOOSE_PRODUCT_category_'+type | uppercase | translate }}
    </h2>-->
    <span
        class="step"
        *ngIf="step"
        role="text"
        attr.aria-label="{{ 'BLOCK_STEP_ARIA_LABEL' | translate }} {{
            (mediumGroups$ | async).length > 1 ? step + 1 : step
        }}"
        >{{ (mediumGroups$ | async).length > 1 ? step + 1 : step }}</span
    >

    <!-- TRAVELCARD INPUT -->
    <ng-container
        *ngIf="
            (selectedMediumGroup$ | async).type === mediumGroupTypes.Travelcard && this.allAllowedCards?.length === 0
        ">
        <h2 class="block-full-width__title">
            {{ 'INSERT_TRAVEL_NUMBER' | translate }}
        </h2>
        <p class="block-full-width-message__content__description" *ngIf="!isEmpty">
            {{ 'VALID_NUMBER' | translate }}
        </p>

        <div class="travel-card" *ngIf="this.allAllowedCards.length === 0 && !isEmpty">
            <div class="travel-card-area">
                <rwidget-travel-card-input
                    [required]="true"
                    [reset]="resetCardInput$"
                    [disabled]="disableCardInput$"
                    (onChange)="setMedium($event)"></rwidget-travel-card-input>
            </div>
        </div>
    </ng-container>

    <!-- TRAVEL CARD INPUT + RELATED CARD LIST -->
    <ng-container
        *ngIf="(selectedMediumGroup$ | async).type === mediumGroupTypes.Travelcard && this.allAllowedCards?.length > 0">
        <h2 class="block-full-width__title">
            {{ 'MEDIUM_STEP_ENTER_OR_CHOOSE_CARD_TITLE' | translate }}
        </h2>
        <p class="block-full-width-message__content__description" *ngIf="!isEmpty">
            {{ 'CHOOSE_CARD_OR_NEW_NUMBER' | translate }}
        </p>

        <div class="tablet-layout" *ngIf="this.allAllowedCards.length > 0 && !isEmpty">
            <div class="select-travel-card-area select-travel-card-area__left select-travel-card-area__select-card">
                <ridango-selectable-block-wrapper
                    [selected]="(selectedCard$ | async) && !(selectedMedium$ | async).cardId">
                    <p class="block-full-width__title">
                        {{ 'TRAVEL_CARD_INPUT_CHOOSE_CARD_TITLE' | translate }}
                    </p>

                    <div class="insert-travel-card-number-area__select-card">
                        <ridango-dropdown
                            [items]="this.allAllowedCards"
                            [placeholderText]="'PH_SELECT_RELATED_CARD' | translate"
                            [isOpened]="dropdownVisible && !dropdownDisabled"
                            [isDisabled]="dropdownDisabled"
                            [selected]="selectedCard$ | async"
                            [type]="'related-card'"
                            (onItemSelected)="setRelatedCard($event)"
                            (onDropdownToggle)="dropdownToggle($event)">
                            <img class="card hide-for-wcag" src="assets/icon_form_card.svg" alt="" />
                            <img class="card show-high-contrast-view" src="assets/icon_form_card-wcag.svg" alt="" />
                        </ridango-dropdown>
                    </div>
                </ridango-selectable-block-wrapper>
            </div>

            <div class="select-travel-card-area__middle">
                <ridango-vertical-or-separator></ridango-vertical-or-separator>
            </div>

            <div class="select-travel-card-area select-travel-card-area__right">
                <ridango-selectable-block-wrapper [selected]="(selectedMedium$ | async).cardId">
                    <p class="block-full-width__title">
                        {{ 'TRAVEL_CARD_INPUT_INSERT_NUMBER_TITLE' | translate }}
                    </p>

                    <rwidget-travel-card-input
                        [reset]="resetCardInput$"
                        [disabled]="disableCardInput$"
                        (onChange)="setMedium($event)"></rwidget-travel-card-input>
                </ridango-selectable-block-wrapper>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="(selectedMediumGroup$ | async).type === mediumGroupTypes.Email">
        <rwidget-email-input
            [reset]="resetCardInput$"
            [disabled]="disableCardInput$"
            [required]="true"
            (onChange)="setMedium($event)">
        </rwidget-email-input>
    </ng-container>
</ridango-block-full-width>

<!-- <ridango-block-full-width [secondaryBlockBackGroundV2]="true">
    <rwidget-voucher-input (onVoucherSelected)="voucherSelected($event)" (onVoucherCancelled)="voucherCancelled()"
        (onVoucherNotValid)="voucherNotValid()"></rwidget-voucher-input>
</ridango-block-full-width> -->

<ng-template #someoneElseCardModal>
    <h1>{{ 'SOMEONE_ELSE_CARD_MODAL_TITLE' | translate }}</h1>
    <p>{{ 'SOMEONE_ELSE_CARD_MODAL_DESCRIPTION' | translate }}</p>

    <div class="margin-bottom-30">
        <div class="block--bg-bullets margin-bottom-20 block">
            <ul
                class="remove-bullets mat-list mat-list--info"
                innerHtml="{{ 'SOMEONE_ELSE_CARD_MODAL_POINTS' | translate }}"></ul>
        </div>
        <p>{{ 'SOMEONE_ELSE_CARD_MODAL_SUB_CONTENT' | translate }}</p>
        <hr />
    </div>

    <div class="flex-align-center flex-justify-between flex">
        <a
            class="link link--emphasized link--action modal-dialog__cancel-link"
            (click)="modalAction(true)"
            (keydown.space)="modalAction(true)"
            (keydown.enter)="modalAction(true)"
            tabindex="0"
            >{{ 'DIALOG_BUTTON_CANCEL' | translate }}</a
        >
        <button
            class="btn btn--big btn--primary margin-left-10 float-right"
            (click)="modalAction()"
            (keydown.space)="modalAction()"
            (keydown.enter)="modalAction()">
            {{ 'SOMEONE_ELSE_CARD_MODAL_CONFIRM_BUTTON' | translate }}
        </button>
    </div>
</ng-template>

<ng-template #unregisteredCardModal>
    <h1>{{ 'UNREGISTERED_CARD_MODAL_TITLE' | translate }}</h1>
    <p>{{ 'UNREGISTERED_CARD_MODAL_DESCRIPTION' | translate }}</p>

    <div class="margin-bottom-30">
        <div class="block--bg-bullets margin-bottom-20 block">
            <p class="text-bold">{{ 'UNREGISTERED_CARD_MODAL_POINTS_TITLE' | translate }}</p>

            <ul
                class="remove-bullets mat-list mat-list--info margin-bottom-30"
                innerHtml="{{ 'UNREGISTERED_CARD_MODAL_POINTS' | translate }}"></ul>

            <p class="text-bold">{{ 'UNREGISTERED_CARD_MODAL_CONTENT_TITLE' | translate }}</p>
            <div innerHtml="{{ 'UNREGISTERED_CARD_MODAL_CONTENT' | translate }}" ridangoTranslatedLink></div>
        </div>
        <p>{{ 'UNREGISTERED_CARD_MODAL_SUB_CONTENT' | translate }}</p>
        <hr />
    </div>

    <div class="flex-align-center flex-justify-between flex">
        <a
            class="link link--emphasized link--action modal-dialog__cancel-link"
            (click)="modalAction(true)"
            (keydown.space)="modalAction(true)"
            (keydown.enter)="modalAction(true)"
            tabindex="0"
            >{{ 'DIALOG_BUTTON_CANCEL' | translate }}</a
        >
        <button
            class="btn btn--big btn--primary margin-left-10 float-right"
            (click)="modalAction()"
            (keydown.space)="modalAction()"
            (keydown.enter)="modalAction()">
            {{ 'UNREGISTERED_CARD_MODAL_CONFIRM_BUTTON' | translate }}
        </button>
    </div>
</ng-template>
